import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { heroStats } from "../data";

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 pb-24 md:pt-40 md:pb-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-accent mb-6"
          >
            U.S. Corporation • Global Vision
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.05 }}
            className="text-5xl sm:text-6xl lg:text-7xl tracking-tightest font-medium text-primary leading-[1.02]"
          >
            Connecting businesses, families and{" "}
            <span className="obled-gradient-text">opportunities</span> across continents.
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-8 text-base md:text-lg leading-relaxed text-muted max-w-xl"
          >
            Obled Corporation is a U.S.-based company founded in 2020 by Stephane Tayoro Koffi.
            We build projects in mobility, courier services, delivery, fintech, healthcare access,
            and Africa business representation.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.25 }}
            className="mt-10 flex flex-wrap gap-4"
          >
            <a
              href="#projects"
              data-testid="hero-explore-btn"
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-white font-medium hover:bg-primary-hover transition-colors"
            >
              Explore Our Ecosystem <ArrowRight size={18} />
            </a>
            <a
              href="#contact"
              data-testid="hero-partner-btn"
              className="inline-flex items-center px-8 py-4 border border-primary text-primary font-medium hover:bg-primary hover:text-white transition-colors"
            >
              Start a Partnership
            </a>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="relative"
        >
          <div className="relative">
            <img
              src="/assets/hero-building.jpg"
              alt="Modern architecture at twilight"
              className="w-full h-[420px] lg:h-[560px] object-cover"
            />
            <div className="absolute inset-0 bg-primary/10" />
          </div>
          <div className="grid grid-cols-2">
            {heroStats.map((s) => (
              <div
                key={s.label}
                data-testid={`hero-stat-${s.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="bg-white border border-line p-6 lg:p-8"
              >
                <div className="text-3xl lg:text-4xl font-display font-medium text-primary">
                  {s.value}
                </div>
                <div className="mt-2 text-sm text-muted">{s.label}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
